<!-- =========================================================================================
    File Name: Landing.vue
    Description: Public service landing page shown at the root URL
                 Nudges users of the legacy underwriting.fides.international platform towards
                 the new fides platform. Italian market only - copy is intentionally hardcoded.
                 Visual treatment is based on the approved mockup (mockup1.html); copy follows
                 the client's finalised "versione aggiornata" concept.
========================================================================================== -->

<template>
  <div class="landing">
    <div class="container">
      <h1 class="title">
        Il tuo account utilizza ancora la versione precedente della piattaforma fides
      </h1>

      <p class="subtitle">
        Aggiorna ora il tuo accesso, accedi subito alla nuova versione di fides
      </p>

      <a :href="fidesUrl" class="btn">
        Accedi a fides
      </a>

      <div class="info">
        <svg
          class="icon"
          viewBox="0 0 24 24"
          fill="none"
          stroke="#ffe600"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
          aria-hidden="true"
        >
          <path d="M9 18h6M10 21h4M12 3a6 6 0 0 0-4 10.5c.7.8 1 1.5 1 2.5h6c0-1 .3-1.7 1-2.5A6 6 0 0 0 12 3z" />
        </svg>
        <p class="info-text">
          Abbiamo rilasciato una nuova versione con funzionalità migliorate, maggiore sicurezza
          e un'esperienza utente più intuitiva:
        </p>
      </div>

      <ul class="features">
        <li>menu unico di tutte le soluzioni assicurative per professionisti, aziende, lifestyle e patrimonio</li>
        <li>portafoglio, lavori in corso, quotazioni, rinnovi in un'unica serie di view</li>
        <li>gestione premi rimesse estratti conto collegata alla tua banca</li>
      </ul>

      <p class="video-caption">
        Guarda il video per una panoramica delle principali funzionalità.
      </p>

      <div class="video" @click="playVideo">
        <video ref="video" :src="videoUrl" :controls="playing" preload="metadata" playsinline></video>
        <div v-if="!playing" class="play"></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Landing',
  data() {
    return {
      playing: false,
      // Served same-origin from public/videos so it loads without a login and avoids the
      // cross-domain "Local Network Access" prompt some browsers show.
      videoUrl: `${process.env.BASE_URL}videos/new-fides-trailer.mp4`,
    };
  },
  computed: {
    // Sends users to the main Fides website, configured via env.
    fidesUrl() {
      return process.env.VUE_APP_LANDING_PAGE_URL || '#';
    },
  },
  methods: {
    playVideo() {
      // After playback starts the native controls own click handling; don't re-trigger.
      if (this.playing) {
        return;
      }
      const video = this.$refs.video;
      if (video) {
        video.play();
        this.playing = true;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.landing {
  min-height: 100vh;
  background: #efefef;
  font-family: Arial, sans-serif;
  color: #000;
}

.container {
  max-width: 800px;
  margin: auto;
  padding: 60px 20px;
}

.title {
  font-size: 52px;
  line-height: 1.15;
  margin: 0 0 24px;
  font-weight: bold;
  color: #000;
}

.subtitle {
  font-size: 26px;
  font-weight: bold;
  line-height: 1.3;
  margin: 0 0 8px;
}

.btn {
  display: block;
  text-align: center;
  background: #ffe600;
  color: #000;
  padding: 22px;
  border-radius: 50px;
  font-weight: bold;
  font-size: 22px;
  text-decoration: none;
  margin: 40px 0;
}

.info {
  display: flex;
  align-items: center;
  gap: 24px;
  margin: 40px 0 16px;
}

.icon {
  flex: 0 0 auto;
  width: 64px;
  height: 64px;
}

.info-text {
  font-size: 22px;
  line-height: 1.35;
  margin: 0;
}

.features {
  font-size: 22px;
  line-height: 1.4;
  margin: 0 0 32px;
  padding-left: 28px;
  // Override the admin template's global list-style reset so bullets show.
  list-style: disc outside;

  li {
    margin-bottom: 12px;
    list-style: inherit;
  }
}

.video-caption {
  font-size: 22px;
  line-height: 1.35;
  margin: 0 0 24px;
}

.video {
  position: relative;
  cursor: pointer;
}

video {
  width: 100%;
  display: block;
}

.play {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 100px;
  height: 100px;
  border: 6px solid #ffe600;
  border-radius: 50%;
  pointer-events: none;

  &::after {
    content: "";
    position: absolute;
    left: 40%;
    top: 28px;
    border-left: 30px solid #ffe600;
    border-top: 18px solid transparent;
    border-bottom: 18px solid transparent;
  }
}

@media (max-width: 640px) {
  .container {
    padding: 40px 16px;
  }

  .title {
    font-size: 34px;
  }

  .subtitle,
  .info-text,
  .features,
  .video-caption {
    font-size: 18px;
  }

  .icon {
    width: 48px;
    height: 48px;
  }

  .btn {
    font-size: 18px;
    padding: 18px;
  }

  .play {
    display: none;
  }
}
</style>
